import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=98c88e3e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=98c88e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c88e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c88e3e')) {
      api.createRecord('98c88e3e', component.options)
    } else {
      api.reload('98c88e3e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=98c88e3e&scoped=true&", function () {
      api.rerender('98c88e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25DDahK1afNj0/JS/teamMember.vue"
export default component.exports